/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function() {
	'use strict';

	const _isObject = (arg) => {
		return arg && typeof arg === 'object';
	};

	const _isFreezable = (arg) => {
		return _isObject(arg) && !Object.isFrozen(arg);
	};

	class ObjectHelper {
		static deepFreezeObject (objToFreeze) {
			if (_isFreezable(objToFreeze)) {
				Object.freeze(objToFreeze);
				const props = Array.isArray(objToFreeze) ? Object.keys(objToFreeze) : Object.getOwnPropertyNames(objToFreeze);
				for (const name of props) {
					const value = objToFreeze[name];
					ObjectHelper.deepFreezeObject(value);
				}
			}
			return objToFreeze;
		}
	}

	return ObjectHelper;
});
